import { tv } from '@/common/theme/tv.config';

export const styles = tv({
  slots: {
    badge: 'absolute right-md top-md',
  },
})();
